import { useFavouriteStops, useSavedTrips } from '@/store/favourites';
import './SettingsScreen.css';

export function SettingsScreen() {
  const { stops } = useFavouriteStops();
  const { trips } = useSavedTrips();

  return (
    <main className="page-container">
      <h1 className="page-title">Settings</h1>

      <section className="settings-section">
        <h2 className="settings-section-title">Favourites</h2>
        <div className="card settings-card">
          <div className="settings-row">
            <span>Saved Stops</span>
            <span className="settings-row-value">{stops.length} stop{stops.length !== 1 ? 's' : ''}</span>
          </div>
          <div className="settings-row">
            <span>Saved Trips</span>
            <span className="settings-row-value">{trips.length} trip{trips.length !== 1 ? 's' : ''}</span>
          </div>
        </div>
      </section>

      <section className="settings-section">
        <h2 className="settings-section-title">Realtime</h2>
        <div className="card settings-card">
          <div className="settings-row">
            <span>Polling Interval</span>
            <span className="settings-row-value">30 seconds</span>
          </div>
        </div>
      </section>

      <section className="settings-section">
        <h2 className="settings-section-title">Storage</h2>
        <div className="card settings-card">
          <div className="settings-row">
            <span>GTFS Database</span>
            <span className="settings-row-value">Not loaded</span>
          </div>
          <div className="settings-row">
            <span>Last Updated</span>
            <span className="settings-row-value">—</span>
          </div>
        </div>
      </section>

      <section className="settings-section">
        <h2 className="settings-section-title">About</h2>
        <div className="card settings-card">
          <div className="settings-row">
            <span>Version</span>
            <span className="settings-row-value">0.1.0</span>
          </div>
          <div className="settings-attribution">
            Data source: <a href="https://opendata.transport.nsw.gov.au/" target="_blank" rel="noopener">Transport for NSW Open Data Hub</a>
          </div>
        </div>
      </section>
    </main>
  );
}
